import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FaUsers, FaChartBar, FaSignOutAlt, FaCog, FaBriefcase, FaBuilding } from 'react-icons/fa';

const RecruiterSidebar = ({ activeTab, setActiveTab }) => {
  const tabs = [
    { id: 'applications', label: 'Applications' },
    { id: 'accepted', label: 'Accepted Candidates' },
  ];

  return (
    <div className="fixed w-64 h-full bg-white border-r border-gray-200">
      <div className="flex flex-col h-full">
        <div className="p-6">
          <h2 className="text-xl font-bold text-gray-800">Recruiter Dashboard</h2>
        </div>
        <nav className="flex-1">
          {tabs.map(tab => (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              className={`w-full text-left px-6 py-3 ${
                activeTab === tab.id
                  ? 'bg-indigo-50 text-indigo-700 border-r-4 border-indigo-700'
                  : 'text-gray-600 hover:bg-gray-50'
              }`}
            >
              {tab.label}
            </button>
          ))}
        </nav>
      </div>
    </div>
  );
};

export default RecruiterSidebar;